import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { legShape } from 'constants/propTypes';
import { Text } from 'components/shared/JourneyDigest/JourneyDigest.styles';
import classOfService from 'constants/propTypes/classOfService';

import { StyledTable, StyledSummaryTickets } from '../ExchangeSummary.styles';

const ExchangeSummaryTicket = ({
  timing,
  origin,
  destination,
  trainNumber,
  classOfService,
  journey,
  direction,
  firstLegIsAbs = false,
  lastLegIsAbs = false,
  isMiceGroup
}) => (
  <StyledSummaryTickets data-cy={`journey-${direction}`}>
    <StyledTable>
      <tbody>
        <tr>
          <td>
            <FormattedMessage id="journeySummary.dept" />:
          </td>
          <td data-id="departure-info" data-testid="table-values">
            <>
              {lastLegIsAbs && <FormattedMessage id="journeyDigest.ABSADSSecondLeg" />}
              {firstLegIsAbs && <FormattedMessage id="journeyDigest.ABSADSFirstLeg" />}
              {!lastLegIsAbs && !firstLegIsAbs && (
                <>
                  {timing.departs}{' '}
                  <Text title={origin.name} underline>
                    {origin.shortCode}
                  </Text>
                </>
              )}
            </>
          </td>
        </tr>

        <tr>
          <td>
            <FormattedMessage id="journeySummary.arrive" />:
          </td>
          <td data-id="arrival-info" data-testid="table-values">
            <>
              {!lastLegIsAbs && !firstLegIsAbs ? (
                <>
                  {timing.arrives}{' '}
                  <Text title={destination.name} underline>
                    {destination.shortCode}
                  </Text>
                </>
              ) : (
                '-'
              )}
            </>
          </td>
        </tr>

        <tr>
          <td>
            <FormattedMessage id="searchBooking.serviceName" />:
          </td>
          <td data-id="train-number" data-testid="table-values">
            {!lastLegIsAbs && !firstLegIsAbs ? trainNumber : '-'}
          </td>
        </tr>

        <tr>
          <td>
            <FormattedMessage id="journeySummary.class" />:
          </td>
          <td data-id="class-of-accomodation" data-testid="table-values">
            {!lastLegIsAbs && !firstLegIsAbs ? classOfService?.name || '-' : '-'}
          </td>
        </tr>

        <tr>
          <td>
            <FormattedMessage id="journeySummary.fare" />:
          </td>
          <td data-id="fare-name" data-testid="table-values">
            {journey?.[0]?.name || journey.productFamily?.name}
            {isMiceGroup ? ' (Mice Group)' : ''}
          </td>
        </tr>
      </tbody>
    </StyledTable>
  </StyledSummaryTickets>
);

ExchangeSummaryTicket.propTypes = {
  journey: PropTypes.arrayOf(legShape),
  firstLegIsAbs: PropTypes.bool,
  lastLegIsAbs: PropTypes.bool,
  timing: PropTypes.shape({
    departs: PropTypes.string,
    arrives: PropTypes.string
  }),
  origin: PropTypes.shape({
    name: PropTypes.string,
    shortCode: PropTypes.string
  }),
  destination: PropTypes.shape({
    name: PropTypes.string,
    shortCode: PropTypes.string
  }),
  trainNumber: PropTypes.string,
  serviceType: PropTypes.shape({
    code: PropTypes.string
  }),
  classOfService: classOfService,
  direction: PropTypes.string,
  isMiceGroup: PropTypes.bool
};

export default ExchangeSummaryTicket;
